import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './NoticeInfo.scss';
import iconSvg from '../../assets/img/svgLib/iconsSvg';
import classNames from 'classnames';
import moment from 'moment';

class NoticeInfo extends Component {
    static propTypes = {
      noticeData: PropTypes.object,
    }

    constructor(props) {
      super(props);

      this.state = {

      };
    }

    get emptyBlock() {
      return (
        <div className={'emptyInfo'}>
          <div className={'block'}>
            <div className={'icon'}>
              {iconSvg.ring}
            </div>
            <div className={'text'}>
                        Выбирите оповещение
                        в левой колонке,
                        для получения подробной
                        информации
            </div>
          </div>
        </div>
      );
    };

    reformatDate = (date) => {
      const now = moment().format('DD.MM.YYYY');
      const yesterday = moment().add(-1, 'days').format('DD.MM.YYYY');
      const tmp = moment(date).format('DD.MM.YYYY');
      return tmp === now ?
            'Сегодня' : yesterday === tmp ?
                'Вчера' : tmp;
    }

    informationBlock() { // TODO Забирать с бэка полную инфу по id уведомления
      const {noticeData} = this.props;
      const {title, data, status, logo, fullTitle} = noticeData;
      console.log(noticeData);
      const reformateDate = this.reformatDate(data);
      // const {} = data; // TODO структура получаемых данных ?????????
      // const tmpData = { // Временные данные для верстки
      //   id: 38,
      //   datePlace: '04.10.18',
      //   name: 'Сервисное расположение буровых растворов',
      //   classificator: 'Имперский крейсер',
      //   dateCompleted: '2018-10-07 15:48:48',
      //   dealNumber: 'ДП-11/1231',
      //   factor: {
      //     id: 12,
      //     name: 'ПАО "Микрозаймы до ЗП"',
      //     logo: '',
      //   },
      //   autoChecking: { //  Возможно лучше объектом key:val выводить циклом если есть разное количество проверок
      //     deal: {doc: 'Договор', val: true},
      //     supplyFact: {doc: 'Подтверждение факта поставки', val: true},
      //     sidesCalculate: {doc: 'Взаимные расчеты сторон', val: false},
      //   },
      //   debtor: {
      //     id: 12,
      //     name: 'Буровые Медведи Сибири',
      //     logo: '',
      //   },
      //   debtorCredit: 100000,
      //   delay: 117,
      //   delayLeft: 67,
      //   amount: 43909644,
      //   nameCompany: 'Honotron',
      //   companyGroup: 'Газпром',
      //   verification: 1,
      //   basket: false,
      // };

      return (
        <div className={'mainBlock'}>
          <div className={'top'}>
            <div className={'date'}>
              {reformateDate}
            </div>
            <div className={'title'}>{title}</div>
            <div className={classNames('status', status)} />
          </div>
          <div className={'header'}>
            {fullTitle}
          </div>
          <div className={'simpleBlock'}>
            <div className={'title'}>Наименование поставки</div>
            <div>{data.name}</div>
            <div className={'title'}>Сумма финансируемой поставки</div>
            <div>{data.amount}</div>
            <div className={'title'}>Номер договора поставки</div>
            <div>{data.dealNumber}</div>
          </div>
          <div className={'simpleBlock'}>
            <div className={'title'}>Поставщик</div>
            <div className={'text'}>
              {data.nameCompany}
              <span>{logo}</span>
            </div>
            <div className={'title'}>Фактор</div>
            <div className={'text'}>
              {data.factor.name}
              <span>{data.factor.logo}</span>
            </div>
          </div>
          <div className={'autoCheckBlock'}>
            <div className={'title'}>
                        Результат автоматической проверки
            </div>
            <div className={'checkItem'}>
              <div className={'checkIcon'} />
              {data.autoChecking.deal.doc
              }</div>
            <div className={'checkItem'}>
              <div className={'checkIcon'} />
              {data.autoChecking.supplyFact.doc}
            </div>
            <div className={'checkItem'}>
              <div className={'checkIcon'} />
              {data.autoChecking.sidesCalculate.doc}
            </div>
            <div className={classNames('title', 'right')}>
                        Данные дебитора:
            </div>
            <div className={'checkItem'}>
              {data.debtor.name}
            </div>
            <div className={classNames('title', 'right')}>
                        Данные поставщика:
            </div>
            <div className={'checkItem'}>
              {`Дебиторская задолжность: ${data.debtorCredit} р`}
            </div>
            <div className={'buttonGroup'}>
              <div
                className={classNames('buttonNext')}>
                            Известить стороны
              </div>
              <div className={'link'}>
                            Изменить данные проверки поставки
              </div>
            </div>
          </div>
        </div>
      );
    }

    render() {
      const {emptyBlock} = this;
      const {noticeData} = this.props;
      return (
        <div className={'informationBlock'}>
          {noticeData && noticeData.id ? this.informationBlock() : emptyBlock}
        </div>
      );
    }
}

export default NoticeInfo;



// WEBPACK FOOTER //
// ./src/shared/Notice/NoticeInfo.js